/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompropertykey2Inputs */

const en_entity_custompropertykey2 = /** @type {(inputs: Entity_Custompropertykey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Key`)
};

const de_entity_custompropertykey2 = /** @type {(inputs: Entity_Custompropertykey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Schlüssel`)
};

/**
* | output |
* | --- |
* | "Custom Property Key" |
*
* @param {Entity_Custompropertykey2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompropertykey2 = /** @type {((inputs?: Entity_Custompropertykey2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompropertykey2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompropertykey2(inputs)
	return de_entity_custompropertykey2(inputs)
});
export { entity_custompropertykey2 as "entity_customPropertyKey" }